import { BOTTOM_MODAL_SHEET_COLLAPSED_HEIGHT } from '@/shared/consts';
import { useBoundStore } from '@/shared/store';
import useIsZoomedOut from '../model/useIsZoomedOut';

const PADDING = 20;

const NaverMapZoomGuide = () => {
	const isZoomedOut = useIsZoomedOut();
	const currentSnapPoint = useBoundStore((store) => store.currentSnapPoint);

	if (!isZoomedOut) return null;

	const bottom =
		(currentSnapPoint ?? 0) >= 2
			? 'calc(50dvh - 22px)'
			: `${BOTTOM_MODAL_SHEET_COLLAPSED_HEIGHT + PADDING}px`;

	return (
		<div
			className="pointer-events-none absolute left-1/2 z-10 -translate-x-1/2"
			style={{
				bottom,
				transition: 'bottom 0.35s cubic-bezier(0.32, 0.72, 0, 1)',
			}}
		>
			<p className="rounded-full bg-mantang-black/60 px-4 py-2 font-inter font-medium text-mantang-white text-sm">
				지도를 확대하세요
			</p>
		</div>
	);
};

export default NaverMapZoomGuide;
